import React, { Fragment,useState,useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/header/Header';
import PageTitle from '../../components/pagetitle/PageTitle';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Footer from '../../components/footer/Footer';
import Graph1 from './Graph1';
import Graph2 from './Graph2';
import Graph3 from './Graph3';
import './charts.css';

import axios from 'axios';

const StatisticsPage = (props) => {
    const navigate = useNavigate();

    // const { slug } = useParams()

    // const EventDetails = Events.find(item => item.slug === slug)


    const port = process.env.REACT_APP_SERVER_PORT;
    const [collegesData, setColleges] = useState({});
        useEffect(() => { 
        // Fetch count by department
        axios.get(`${port}count-by-department`)
            .then((result) => {
                // Handle the result
                //console.log('mylog')
                //console.log(result.data.xAxis[0].data)
                //console.log(result.data)
                setColleges(result.data);
                //console.log("col data")
                //console.log(collegesData)

            })
            .catch((error) => {
                console.error("Error fetching count by department:", error);
            });
    
        // Fetch college names
        axios.get(`${port}get-college-names`)
            .then((result) => {
                // console.log("Api data")
                console.log(result.data);
                setCollegeName(result.data);    
            })
            .catch((error) => {
                console.error("Error fetching college names:", error);
            });

    }, [port]); // Added `port` as a dependency
    


    const [collegeName, setCollegeName] = useState({
        "": "All colleges",
        "AEC": "Aditya Engineering College",
        "ACOE":  "Aditya College of Engineering"
    })

    const option = '';

    return (
        <Fragment>
            <Header hclass={'header--styleFour'} />
            <main className='main'>
            <PageTitle pageTitle={'STATISTICS'} pagesub={'STATISTICS'} />
                <section className="about">
                   <div className="header-stat">
                        <div className='drop-down-clgs'>
                            <button onClick={() => navigate('/blooddonation/live-counts')} className='live-counts-btn'>
                                Live Counts
                            </button>
                        </div>
                    </div>
                    <div className='graph-container'>
                        <div style={{ textAlign: "center", marginBottom: "20px" }}>
                            <h3 className="sectionTitle__big" style={{ fontSize: "24px", fontWeight: "600", color: "#1e1b4b" }}>
                                {collegeName[option]? collegeName[option] : option}
                            </h3>
                            <div className="title-bar" style={{ width: "32px", height: "3px", backgroundColor: "#ff0000", margin: "8px auto 0", borderRadius: "2px" }}></div>
                        </div>
                        <div className="charts-grid-main">
                            <div className="Graph-row-top">
                                <Graph1 college={option}/>
                            </div>
                            <div className="Graph-row-bottom">
                                <Graph2 college={option}/>
                                <Graph3 college={option}/>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            <Footer />
            <Scrollbar />
        </Fragment>
    );
};

export default StatisticsPage;